/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Created/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ManualSyncAction from './ManualSyncAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Created({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/Content/Created"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Created.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 size="large"
 text="Awaiting scan results from My iTero™"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 size="large"
 text="Scan results will automatically sync with Greyfinch once the scan is complete."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Please wait a few moments until the scan has processed."
/>
<ManualSyncAction
  viewPath={`${viewPath}/ManualSyncAction`}
/>
</div>
{children}
</React.Fragment>)
}